import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field, change, FieldArray } from 'redux-form';
import { Grid } from './../../../assets/theme/layout';
import { Page, Wrapper, Paper, Content, Loading, Button, Toolbar, ButtonsGroup } from './../../../components/ui';
import { InputTextField, SelectField, OptionField } from './../../../components/ui/input';
import { StoreAutocompleteMultiple } from './../../../scenes';
import { OfferService } from './../../../services';
import { isSlug, findPermissionProps, filterIds } from './../../../utilities/utils';

import API from './../../../config/api';
import TEXT from './../../../config/text';

const validate = values => {
  const errors = {};

  if (!values.name) {
    errors.name = TEXT.validation.required;
  } else if (values.name.length > 255) {
    errors.name = TEXT.validation.maxlength(255);
  }

  if (!values.title) {
    errors.title = TEXT.validation.required;
  } else if (values.title.length > 1024) {
    errors.title = TEXT.validation.maxlength(1024);
  }

  if (!values.source) {
    errors.source = TEXT.validation.required;
  } else if (values.source.length > 255) {
    errors.source = TEXT.validation.maxlength(255);
  } else if (!isSlug(values.source)) {
    errors.source = TEXT.validation.slug_invalid;
  }

  return errors;
};

const renderItemsForIds = ({ fields }) => (
  fields.length > 0 && (
    fields.map((entity, index) => (
      <Field
        key={ index }
        name={ entity }
        component={ InputTextField }
        type="text"
        fieldHidden
      />
    ))
  )
);

class Page__OfferManualForm extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      permission: null,
      loading: true,
      id: null,
      name: '...',
      title: 'Nueva promoción manual',
      submited: false,
      stores: []
    };
  }

  componentDidMount(){
    this._Init();
  }

  _Init = () => {
    const id = this.props.match.params.id;

    this.setState({
      permission: findPermissionProps(this.props.session, API.permissions.offer, 'Ofertas')
    });

    if (id) {
      this._Find(id);
    } else {
      this.setState({ loading: false, title: 'Nueva promoción manual' });
    }
  };

  _Find = (id) => {
    OfferService.find(id).then((response) => {
      const form = this.props.form;
      const offer = response.offer;

      this.setState({
        loading: false,
        id: offer._id,
        title: offer.name,
        stores: offer.stores || []
      });

      this.props.dispatch(change(form, 'name', offer.name || '' ));
      this.props.dispatch(change(form, 'title', offer.title || '' ));
      this.props.dispatch(change(form, 'source', offer.source || '' ));
      this.props.dispatch(change(form, 'enabled', String(offer.enabled) ));
      this.props.dispatch(change(form, 'stores', filterIds(offer.stores) ));
    }).catch((error) => {
      this.setState({ loading: false });

      this.props.alertShow({
        open: true,
        severity: 'error',
        message: error.data ? error.data.message : TEXT.message.error
      });
    });
  };

  _Save = (values) => {
    this.setState({ submited: true });

    OfferService.save({ ...values, published: false, manual: true }).then(() => {
      this.props.alertShow({
        open: true,
        severity: 'success',
        message: TEXT.message.success
      });

      this.props.history.push('/offer');
    }).catch((error) => {
      this.setState({ submited: false });

      this.props.alertShow({
        open: true,
        severity: 'error',
        message: error.data ? error.data.message : TEXT.message.error
      });
    });
  };

  _Update = (id, values) => {
    this.setState({ submited: true });

    OfferService.update(id, { ...values, published: false, manual: true }).then(() => {
      this.props.alertShow({
        open: true,
        severity: 'success',
        message: TEXT.message.success
      });

      this.props.history.push('/offer');
    }).catch((error) => {
      this.setState({ submited: false });

      this.props.alertShow({
        open: true,
        severity: 'error',
        message: error.data ? error.data.message : TEXT.message.error
      });
    });
  };

  handleOnSelectStore = (stores) => {
    this.props.dispatch(change(this.props.form, 'stores', stores ? filterIds(stores) : [] ));
    this.setState({ stores });
  }

  handleSubmitForm = (values) => {
    if (this.state.id) {
      this._Update(this.state.id, values);
    } else {
      this._Save(values);
    }
  };

  render(){

    const { handleSubmit, invalid, t } = this.props;
    const { permission, loading, name, title, submited, stores } = this.state;

    return(
      <Page>
        <Wrapper>
          <Toolbar title={permission ? permission.name : name} dividerMobile>
            <Button component={ NavLink } to="/offer" icon="back" size="medium">
              {t('button.back')}
            </Button>
          </Toolbar>

          <Paper disablePadding>
            <Toolbar title={ title } size="medium" variant="divider" disableMargin />

            { loading ? (
              <Content>
                <Loading/>
              </Content>
            ) : (
            <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>
              <Content divider disableMargin>
                { submited && (
                  <Loading variant="absolute"/>
                )}

                <Content marginBottom>
                  <Toolbar title="Datos básicos" size="small" />
                  <Grid container spacing={3}>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <Field
                        name="name"
                        component={ InputTextField }
                        label={t('field.name')}
                        type="text"
                        required
                      />
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <Field
                        name="title"
                        component={ InputTextField }
                        label={t('field.title')}
                        type="text"
                        required
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <Field
                        name="source"
                        component={ InputTextField }
                        label={t('field.campaign')}
                        type="text"
                        required
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <Field
                        name="enabled"
                        component={ SelectField }
                        label={t('field.status')}
                        required
                      >
                        <OptionField value="true">Activo</OptionField>
                        <OptionField value="false">Bloqueado</OptionField>
                      </Field>
                    </Grid>
                  </Grid>
                </Content>

                <Content marginBottom>
                  <Toolbar
                    title={t('text.stores')}
                    subtitle="Opcional"
                    size="small"
                  />
                  <Grid container spacing={3}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <StoreAutocompleteMultiple
                        stores={stores}
                        onSelect={this.handleOnSelectStore}
                      />

                      <FieldArray
                        name="stores"
                        component={ renderItemsForIds }
                      />
                    </Grid>
                  </Grid>
                </Content>
              </Content>

              <Content>
                <ButtonsGroup align="right">
                  <Button component={ NavLink } to="/offer" color="danger" size="medium" icon="cancel">
                    {t('button.cancel')}
                  </Button>
                  <Button type="submit" size="medium" icon="add" color="success" disabled={ invalid || submited }>
                    {t('button.save')}
                  </Button>
                </ButtonsGroup>
              </Content>
            </form>
            )}
          </Paper>
        </Wrapper>
      </Page>
    )
  }
}

Page__OfferManualForm = reduxForm({
  form: 'Page__OfferManualForm',
  validate,
  initialValues: {
    enabled: 'true',
    stores: []
  }
})(Page__OfferManualForm);

const mapStateToProps = (state) => ({ session: state.userState });

const mapDispatchToProps = (dispatch) => ({
  alertShow: (data) => dispatch({ type: 'ALERT_SHOW', data: data })
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Page__OfferManualForm));
